module.exports = __webpack_public_path__ + "static/media/bose-quietcontrol-30.f4c84331.png";